import { BoloPanelFormType } from '@mark43/cad-api';
import { getDefaultPerson } from '../../../event-panel/event-panel-form/involved-person-vehicle-fields/persons/helpers';

export const getBoloPanelFormStubValues = (boloId?: number): BoloPanelFormType => ({
    boloType: null,
    description: '',
    dispatchAreaRecipients: [],
    involvedPersons: boloId ? [getDefaultPerson()] : [],
    involvedVehicles: [],
    labels: [],
    location: null,
    locationNotes: '',
    locationSubPremise: '',
    priority: null,
    scheduledExpirationDate: '',
    subdivisionRecipients: [],
    id: boloId ?? null,
});
